<template>
  <b-card>
    <div
      class="d-flex flex-column align-items-center"
    >
      <h4>
        Wallet
      </h4>
      <b-badge
        pill
        :variant="`${useWallet ? 'success' : 'danger'}`"
        style="padding:8px 14px"
      >
        {{ useWallet ? 'Enabled' : 'Disabled' }}
      </b-badge>
      <!-- <span>
        Paid By Wallet : {{ paidByWallet }}
      </span> -->

    </div>
  </b-card>
</template>

<script>
import {
  BCard, BBadge,
} from 'bootstrap-vue'
import { computed } from '@vue/composition-api'

export default {
  components: {
    BCard,
    BBadge,
  },
  setup(_, ctx) {
    const tripBillDetails = computed(() => ctx.root.$store.getters['trips/getTripBillDetails'])
    const useWallet = computed(() => tripBillDetails.value?.meta?.inbound_data?.use_wallet)

    return {
      tripBillDetails,
      useWallet,
    }
  },
}
</script>

<style>

</style>
